import { toast, ToastOptions } from 'react-toastify';
import { IS_NATIVE } from '@r3l/common';
import { Alert as RAlert } from 'react-native';

const IS_BROWSER = process.env.BROWSER;

export const browserAlerts = {
  alert: (message: string, alertType: ToastOptions['type']): void => {
    toast(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      type: alertType || 'error',
      hideProgressBar: true,
    });
  },
};

const getAlert = (): any => {
  if (IS_NATIVE) return RAlert;
  if (IS_BROWSER) return browserAlerts;

  // eslint-disable-next-line
  return { alert: (a: string, b: string) => console.log(a, ' ', b) };
};

export const Alert = getAlert;
export const UAlert = getAlert().alert;
